import { getData , postData , putData , deleteData } from './index';
import { sortByUpdateDate } from '../utils/utils';

import {
  GET_PARTNERS,
  POST_PARTNER,
  DELETE_PARTNER,
  UPDATE_PARTNER,
  ERROR_PARTNERS,
} from "./types"

export async function getPartnersAction(dispatch, lang) {
  let url = "/partner/lang/" + lang;
  var partners = [];

  await getData(ERROR_PARTNERS, url, dispatch, true).then((response) => {
    partners = response.partners;
  });

  dispatch({
    type: GET_PARTNERS,
    payload: sortByUpdateDate(partners)
  });
}

export async function createPartnerAction(dispatch, params) {
  let url = "/partner";
  var partner;

  await postData(POST_PARTNER, ERROR_PARTNERS, url, dispatch, params, true).then((response) => {
    partner = response;
  });

  dispatch({
    type: POST_PARTNER,
    payload: partner
  });
}

export async function updatePartnerAction(dispatch, param) {
  let url = "/partner/" + param._id;
  var partner;

  await putData(UPDATE_PARTNER, ERROR_PARTNERS, url, dispatch, param, true).then((response) => {
    partner = response;
  });

  dispatch({
    type: UPDATE_PARTNER,
    payload: partner
  });
}

export async function deletePartnerAction(dispatch, id) {
  let url = "/partner/" + id;

  await deleteData(ERROR_PARTNERS, url, dispatch, true).then(() => {
    dispatch({
      type: 'SET_TOAST',
      payload: {
        message: "Le partenaire a bien été supprimé",
        type: "success"
      }
    });
  });

  dispatch({
    type: DELETE_PARTNER,
    payload: id
  });
}
